/**
 * Simple wrapper for console.log
 * Logging is disabled in production builds
 * unless REACT_APP_ENABLE_LOGGING is set to true
 */
declare var process: {
    env: {
        NODE_ENV?: string;
        REACT_APP_ENABLE_LOGGING?: string;
    };
};

// tslint:disable no-any
const noOp = (..._args: any[]) => {};

let info: any = noOp;
let debug: any = noOp;
let error: any = noOp;
let warn: any = noOp;

function isLoggingEnabled() {
    const isProduction = process.env.NODE_ENV === "production";
    const enableLogging = process.env.REACT_APP_ENABLE_LOGGING === "true";

    // in non-production builds logging is enabled by default
    if (!isProduction) {
        return true;
    }

    // otherwise log only if REACT_APP_ENABLE_LOGGING is set to "true";
    return enableLogging;
}

if (isLoggingEnabled()) {
    info = console.log.bind(console);
    debug = console.log.bind(console);
    error = console.error.bind(console);
    warn = console.warn.bind(console);
}

export default {
    log: info,
    info,
    debug,
    error,
    warn,
};



// WEBPACK FOOTER //
// ./src/util/logger.ts